import React, { useMemo } from 'react'

import toUpper from 'lodash/toUpper'

import { useT } from '@galo-monitor/i18n'
import Screen from '@galo-monitor/web-components/Screen'
import TabsPanelRoutes from '@galo-monitor/web-components/TabsPanelRoutes'
import { useRoutes } from '@galo-monitor/web-containers/routes/authenticated'

import Brands from './tabs/Brands'
import Models from './tabs/Models'

const BrandsModelsScreen = () => {
  const { routes, urlHasPermission } = useRoutes()
  const t = useT()

  const tabs = useMemo(
    () => {
      const response = []

      const addTab = tab => {
        if (urlHasPermission(tab.slug, 'root')) {
          response.push(tab)
        }
      }

      addTab({
        route: 'brands',
        slug: 'gerenciamento-de-maquinas-farm',
        title: toUpper(t('brand', { howMany: 2 })),
        Component: Brands
      })

      addTab({
        route: 'models',
        slug: 'gerenciamento-de-maquinas-farm',
        title: toUpper(t('model', { howMany: 2 })),
        Component: Models
      })

      return response
    },
    [t, urlHasPermission]
  )

  const crumbs = useMemo(() => [
    {
      title: routes.brandsModels.title,
      key: 'brands-models-screen',
      url: '/database/brands',
      active: true
    }
  ], [routes.brandsModels.title])

  return (
    <Screen title={ routes.brandsModels.title } breadcrumbs={ crumbs } removeDivider>
      <TabsPanelRoutes itens={ tabs } />
    </Screen>
  )
}

export default BrandsModelsScreen
